export default __webpack_public_path__ + "static/media/cabello-corto-hombre-castano.2c00b732.png";